import GraceListRowLink from './ListRowLink';

const ListRowLinkGroup = ({ iterable, idKey, displayTextKey, photoKey = null, onClick }) => {
  return iterable.map(i => {
    return (
      <GraceListRowLink
        key={i[idKey]}
        displayText={i[displayTextKey]}
        photo={photoKey ? i[photoKey] : null}
        onClick={() => {
          onClick(i);
        }}
      />
    );
  });
};

export default ListRowLinkGroup;
